import script from "./ActiveIncidents.vue?vue&type=script&setup=true&lang=js"
export * from "./ActiveIncidents.vue?vue&type=script&setup=true&lang=js"

import "./ActiveIncidents.vue?vue&type=style&index=0&id=11d4f2af&lang=css"

const __exports__ = script;

export default __exports__